import {gql} from '@apollo/client';

export const PauseSubscriptionQuery = gql`
  query PauseSubscriptionQuery {
    me {
      id
      customerAccount {
        id
        subscription {
          id
          items {
            id
            productId
            variantId
            variantSku
            title
            quantity
            price
          }
          pausedProductVariantIds
        }
      }
    }
  }
`;

export const PauseSubscriptionItemsMutation = gql`
  mutation PauseSubscriptionItemsMutation($input: PauseSubscriptionItemsInput!) {
    pauseSubscriptionItems(input: $input) {
      id
    }
  }
`;
